import {
  type PriceBookId,
  priceBookIdFormat,
} from "@redotech/redo-marketplace-id";

export type MembershipTier = "gold" | "silver" | "bronze";

// TODO: replace these placeholders with the real Gold/Silver/Bronze price book
// ids once the tier price books exist.
export const MEMBERSHIP_TIER_PRICE_BOOK_IDS: Record<
  MembershipTier,
  PriceBookId
> = {
  gold: priceBookIdFormat.write(BigInt("7462400972193780242")),
  silver: priceBookIdFormat.write(BigInt("1836277410751480010")),
  bronze: priceBookIdFormat.write(BigInt("6207274858598519623")),
};

const TIER_BY_PRICE_BOOK_ID = new Map<PriceBookId, MembershipTier>(
  Object.entries(MEMBERSHIP_TIER_PRICE_BOOK_IDS).map(([tier, id]) => [
    id,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    tier as MembershipTier,
  ]),
);

/** The membership tier a price book represents, or null for a non-tier book. */
export function getMembershipTier(
  priceBookId: PriceBookId,
): MembershipTier | null {
  return TIER_BY_PRICE_BOOK_ID.get(priceBookId) ?? null;
}
